import { Button, Segmented } from 'antd';
import { Plus } from 'lucide-react';

interface AccessorialToolbarProps {
  isCurrent: boolean;
  onToggle: (isCurrent: boolean) => void;
  /** Present only when the user may add a rate to this card. */
  onAdd: (() => void) | null;
}

export function AccessorialToolbar({ isCurrent, onToggle, onAdd }: AccessorialToolbarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <Segmented
        value={isCurrent ? 'current' : 'superseded'}
        options={[
          { value: 'current', label: 'Current' },
          { value: 'superseded', label: 'Superseded' },
        ]}
        onChange={(value) => onToggle(value === 'current')}
      />
      {onAdd && (
        <Button type="primary" icon={<Plus className="size-4" />} onClick={onAdd}>
          Add accessorial rate
        </Button>
      )}
    </div>
  );
}
